export const SUCCESS_VERIFY_LINK: string = "A verification link has been successfully sent to your email address.";
export const EMAIL_NOT_FOUND: string = "This email address doesn't exist";
export const EMAIL_ALREADY_EXISTS: string = "This email address already exists";
